module.exports = __webpack_public_path__ + "img/logo.ee92fa0e.png";